export const CONTACT = {
  name: 'Klub Sportowy SMP „Wichniarek"',
  address: 'Os. B. Śmiałego 37/79, 60-682 Poznań',
  nip: '9721241201',
  phone: '+48 500 111 775',
  email: 'biuro@szkolka-wichniarek.pl',
  bank: 'Santander Bank Polska 07 1090 1463 0000 0001 1945 8800',
  facebook: 'https://www.facebook.com/szkolkawichniarek',
};

export const NAV_LINKS = [
  { href: '#o-nas', label: 'O nas' },
  { href: '#co-robimy', label: 'Co robimy' },
  { href: '#szkolenie', label: 'Szkolenie' },
  { href: '#galeria', label: 'Galeria' },
  { href: '#lokalizacje', label: 'Lokalizacje' },
  { href: '#kontakt', label: 'Kontakt' },
];

export const LOCATIONS = [
  {
    id: 'sp89',
    name: 'Szkoła Podstawowa nr 89',
    address: 'ul. Sochaczewska 3, Poznań',
    note: 'Treningi dla klas 0–IV w sali gimnastycznej i na boisku szkolnym.',
    map: 'https://maps.google.com/maps?q=Sochaczewska%203%2C%20Pozna%C5%84&t=&z=15&ie=UTF8&iwloc=&output=embed',
  },
  {
    id: 'kraina',
    name: 'Przedszkole „Kraina Baśni"',
    address: 'ul. Kaliowa 39, Poznań',
    note: 'Zajęcia piłkarskie dla przedszkolaków — nauka przez zabawę.',
    map: 'https://maps.google.com/maps?q=Kaliowa%2039%2C%20Pozna%C5%84&t=&z=15&ie=UTF8&iwloc=&output=embed',
  },
  {
    id: 'zse2',
    name: 'Zespół Szkół Elektrycznych nr 2',
    address: 'ul. Świt 25, Poznań',
    note: 'Treningi grup starszych na pełnowymiarowym boisku.',
    map: 'https://maps.google.com/maps?q=%C5%9Awit%2025%2C%20Pozna%C5%84&t=&z=15&ie=UTF8&iwloc=&output=embed',
  },
  {
    id: 'orlik',
    name: 'Boisko Orlik',
    address: 'ul. Jarochowskiego 20, Poznań',
    note: 'Treningi na świeżym powietrzu na nowoczesnym boisku Orlik.',
    map: 'https://maps.google.com/maps?q=Jarochowskiego%2020%2C%20Pozna%C5%84&t=&z=15&ie=UTF8&iwloc=&output=embed',
  },
];

export const GROUPS = [
  {
    name: 'Przedszkolaki',
    ages: '4–6 lat',
    desc: 'Zabawy ruchowe z piłką, koordynacja i pierwsze kroki z podstawami techniki.',
    focus: ['Nauka przez zabawę', 'Koordynacja ruchowa', 'Pierwsze kontakty z piłką'],
  },
  {
    name: 'Klasy I–III',
    ages: '7–9 lat',
    desc: 'Fundamenty techniki: prowadzenie piłki, podania, przyjęcia. Małe gry i dużo radości.',
    focus: ['Technika indywidualna', 'Małe gry 3v3 / 4v4', 'Współpraca w zespole'],
  },
  {
    name: 'Klasy IV–VI',
    ages: '10–12 lat',
    desc: 'Rozwój techniki w warunkach meczowych, podstawy taktyki i regularne turnieje.',
    focus: ['Technika w tempie', 'Podstawy taktyki', 'Turnieje ligowe'],
  },
  {
    name: 'Młodzicy',
    ages: '13–15 lat',
    desc: 'Zaawansowane szkolenie przygotowujące do gry w klubach młodzieżowych.',
    focus: ['Szkolenie zaawansowane', 'Przygotowanie motoryczne', 'Droga do klubu'],
  },
];

export const STAFF = [
  {
    name: 'Grzegorz Wichniarek',
    role: 'Koordynator / trener',
    desc: 'Tel. 500 111 775',
  },
  {
    name: 'Waldemar Hoffmann',
    role: 'Trener',
    desc: 'Tel. 501 069 230',
  },
  {
    name: 'Bartosz Zawadzki',
    role: 'Trener',
    desc: 'Tel. 507 127 049',
  },
  {
    name: 'Armin Bezler',
    role: 'Trener',
    desc: 'Tel. 512 509 394',
  },
  {
    name: 'Bartłomiej Kryczka',
    role: 'Trener',
    desc: 'Tel. 661 076 968',
  },
];

export const GALLERY = [
  { src: '/gallery/m3.jpg', label: 'Strzał na bramkę', span: 'md:col-span-2 md:row-span-2' },
  { src: '/gallery/g3.jpg', label: 'Awans do finału Ligi Młodych Talentów', span: 'md:col-span-2' },
  { src: '/gallery/n2.jpg', label: 'Trening w hali', span: '' },
  { src: '/gallery/n4.jpg', label: 'Liga Red Box — dekoracja', span: '' },
  { src: '/gallery/m1.jpg', label: 'Liga MT — Finalista 2026', span: 'md:col-span-2' },
  { src: '/gallery/g5.webp', label: 'Mecz — walka o piłkę', span: '' },
  { src: '/gallery/g4.jpg', label: 'Odprawa z trenerem', span: '' },
];

export const IMG = {
  hero: '/gallery/g2.jpg',
  individual: '/gallery/n2.jpg',
  tournaments: '/gallery/n4.jpg',
  training: '/gallery/n5.webp',
};
